import React, { ChangeEvent, createRef, useRef, useState } from 'react';
import { Button, Image } from 'semantic-ui-react';
import { exportComponentAsPNG } from 'react-component-export-image';

import SubtitleItem from './SubtitleItem';

import './PictureArea.css';
import placeholderImg from '../placeholder.png';

/** 
 * 画像エリアコンポーネント
 */
type PictureAreaProps = {
  subtitleParam: { text: string, left: number, colorCode: string }[];
}
function PictureArea(props: PictureAreaProps) {
  const [picSrc, setPicSrc] = useState(placeholderImg);
  const [isSaveProcessing, setIsSaveProcessing] = useState(false);
  const fileRef = createRef<HTMLInputElement>();
  const canvasRef = useRef<any>();

  const onChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files === null) return;
    const file = event.target.files.item(0)
    if (file === null) return;

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setPicSrc(reader.result as string);
    }
  }

  // === ドラッグ＆ドロップ関連
  const onDragEnter = (event: any) => {
    event.preventDefault();
  }
  const onDragOver = (event: any) => {
    event.preventDefault();
  }
  const onDrop = (event: any) => {
    event.preventDefault();
    const files: File[] = event.target.files || event.dataTransfer.files;
    if (files.length === 0 || files[0] === undefined) return;
    if (!files[0].type.startsWith('image/')) {
      // ファイルの種類が画像以外の場合は無視
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      setPicSrc(reader.result as string);
    }
  }

  return (
    <div className='PictureArea'>
      {/* 画像選択用input（隠し要素） */}
      <input type='file' ref={fileRef} onChange={onChangeFile} style={{ display: 'none' }} accept='image/*' />
      <div
        ref={canvasRef}
        className='CaptureCanvas'
        onDragEnter={onDragEnter}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <Image src={picSrc} style={{ width: 100 + '%', height: 'auto' }}/>
        <div className='SubtitleArea'>
          {[0, 1, 2, 3].map(idx => {
            return (<SubtitleItem
              key={idx}
              text={props.subtitleParam[idx].text}
              left={props.subtitleParam[idx].left}
              colorCode={props.subtitleParam[idx].colorCode} />)
          })}
        </div>
      </div>

      <div className='PictureOperationButtonArea'>
        <Button
          size='large'
          onClick={() => {if (fileRef.current) fileRef.current.click()}}>画像を選択する</Button>
        <Button
          size='large'
          loading={isSaveProcessing}
          onClick={() => {
            setIsSaveProcessing(true);
            exportComponentAsPNG(canvasRef, { fileName: 'output.png' }).finally(() => setIsSaveProcessing(false));
          }}
        >画像を保存する</Button>
      </div>
    </div>
  );
}

export default PictureArea;